module.exports = ".inputs-no-radius mat-form-field {\n  width: 100%;\n  display: block; }\n"